import { getState, modifyState } from '~src/state';

async function checkClipboardEnabled() {
  try {
    await navigator.clipboard.readText();
    return true;
  } catch (err) {
    try {
      await navigator.clipboard.writeText(JSON.stringify({ objects: [] }));
      await navigator.clipboard.readText();
      return true;
    } catch (err2) {
      return false;
    }
  }
}

export async function copyToClipboard(stringValue) {
  const isClipboardEnabled = await checkClipboardEnabled();
  const json = JSON.stringify(stringValue);
  if (!isClipboardEnabled) {
    modifyState('clipboardFallback', json);
    console.debug('Copying to clipboard with fallback');
    return;
  }

  try {
    console.debug('Copying to clipboard');
    await navigator.clipboard.writeText(json);
  } catch (err) {
    console.error('Could not copy text: ', err);
  }
}

export async function readFromClipboard() {
  const isClipboardEnabled = await checkClipboardEnabled();
  if (!isClipboardEnabled) {
    return getState('clipboardFallback');
  }

  return await navigator.clipboard.readText();
}
